import { render } from "./loginpage.vue?vue&type=template&id=16758b0c"
import script from "./loginpage.vue?vue&type=script&lang=js"
export * from "./loginpage.vue?vue&type=script&lang=js"

import exportComponent from "E:\\DeepakKumarJha\\TfsProjects\\BeeNeeGit\\CompStoreFront\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__